<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex sm12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Bulk Email</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>                        
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-form class="ldmx-form">
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12 text-xs-right>
                                        <v-btn href="/static/emails.csv" download color="orange darken- white--text">
                                            <v-icon>fa fa-download</v-icon>&nbsp;&nbsp;CSV TEMPLATE
                                        </v-btn>
                                    </v-flex>                                    
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-select :items="templatesList" data-vv-name="template_id" v-validate="{'required':true}" :error-messages="errors.collect('template_id')" v-model="form.template_id" data-vv-as="Templates" item-text="name" item-value="id" label="Email Template">
                                        </v-select>
                                    </v-flex>                                    
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-tabs slider-color="orange">
                                                <template>
                                                    <v-tab @click="clearFormField();form.is_csv = false;"><strong>Add Manually</strong></v-tab>
                                                </template>
                                                <template>
                                                    <v-tab @click="clearFormField();form.is_csv = true;activateDragAndDrop();"><strong>Add CSV</strong></v-tab>
                                                </template>
                                            <template>
                                                <v-tab-item touchless>
                                                    <v-card-text class="pa-0 mt-2" v-if="!form.is_csv">
                                                        <v-layout row wrap >
                                                            <v-flex lg12 md12 xs12>
                                                                <v-textarea label="Add recipients by comma separate" v-validate="{'required':true,'multiEmailValidate':[]}" v-model="form.user_emails" data-vv-name="user_emails" data-vv-as="email" placeholder="" :error-messages="errors.collect('user_emails')">
                                                                </v-textarea>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-tab-item>
                                            </template>
                                            <template>
                                                <v-tab-item touchless>
                                                    <v-card-text class="pa-0 mt-2" v-if="form.is_csv">
                                                        <v-layout row wrap >
                                                            <v-flex lg12 md12 customImgWrap>
                                                                <div class="customImg" id="file-drag-drop">
                                                                    <form ref="myFiles">
                                                                        <v-icon>cloud_upload</v-icon><br>
                                                                        <p class="dragtxt">Drag files to upload</p>
                                                                        <p class="ortxt">Or</p>
                                                                        <v-btn slot="activator" color="orange darken- white--text" @click="$refs.inputUpload.click()">
                                                                            <v-icon>search</v-icon>&nbsp;&nbsp;CHOOSE FILE
                                                                        </v-btn>
                                                                        <input v-show="false"
                                                                            type="file" 
                                                                            id="file" 
                                                                            ref="inputUpload" 
                                                                            class="custom-file-input " 
                                                                            @change="onFileChange($event.target.files)"
                                                                        >
                                                                        <p v-if="fileObj[0]">
                                                                            <strong class="link-text">     
                                                                                File selected to bulk emails :
                                                                                <span>{{fileObj[0] ? fileObj[0].name : ''}}</span>
                                                                            </strong>
                                                                        </p>
                                                                    </form>
                                                                </div>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-tab-item>
                                            </template>
                                        </v-tabs>
                                    </v-flex>            
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex lg12 md12 >
                                        <div class="form-btn text-xs-right">
                                            <v-btn color="green  white--text" @click="submit"> Send mail </v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import {Validator, ErrorBag} from 'vee-validate';
import utils from '../../util/';
import config from '../../config';
Validator.extend('multiEmailValidate', {
    getMessage: field => "The "+field+" field must be a valid email",
    validate: async function (value) {
        let v = new Validator();
        let emailsArr = value.split(',');
        let returnStatus = true;

        let resValid = await emailsArr.map(async function(email){
            let { valid, errors } = await v.verify(email.trim(),'email');
            return valid;
        });
        const numFruits = await Promise.all(resValid)
        return !numFruits.includes(false);
    }
});
export default {
    $_veeValidate: {
        validator: "new"
    },
    created() {
        this.utils = utils;
        const self = this;
        if(!self.$store.state.user.Issuperadmin){
            self.$router.push('/AccessDenied')
        }
        services
            .get("users/list/sendgrid-templates", {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                if (res.status === 200) {
                    self.templatesList.push({
                        'name': 'Please Select Template',
                        'id': ''
                    });
                    res.data.templates.map(function (data) {
                        let newArr = {};
                        newArr.name = data.name;
                        newArr.id = data.id;
                        self.templatesList.push(newArr);
                    })
                }                    
            })
            .catch(err => {
                console.log(err.message)
            });
    },
    components: {
        GoogleAds
    },
    data() {
        return {
            form: {
                template_id: null,
                user_emails: "",
                is_csv: false
            },
            InfoDialog:false,
            templatesList:[],
            dragAndDropCapable: false,
            allowFileExtDoc:['csv'],
            fileObj: {}
        }
    },
    mounted() {
        this.$validator.localize("en", this.dictionary);
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },        
        submit() {
            const self = this,
                wApp = window.getApp;
            self.$validator
                .validateAll()
                .then(isValid => {
                    if(self.form.is_csv && typeof self.fileObj[0] == 'undefined'){
                        self._showToast(config.errAutoloader, config.errMsgColorStr);
                        return false;
                    } else if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        let postData = {};
                        if(!self.form.is_csv){
                            postData = self.form;
                            postData.user_emails = postData.user_emails.trim(',');
                            delete postData.file;
                            services.post("users/send-emails", postData, {
                                    Authorization: "Bearer " + this.$store.state.user.token
                                })
                            .then(res => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                if (!res.data.is_error) {
                                    self._showToast(res.data.message);
                                    self.form.template_id = null;
                                    self.form.user_emails = "";
                                    self.$validator.reset();
                                } else {
                                    self._showToast(res.data.message, "red");
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, "red");
                            });
                        } else {
                            let postData = new FormData();
                            postData.append('file',self.fileObj[0]);
                            postData.append("template_id", self.form.template_id);
                            postData.append("is_csv", self.form.is_csv);
                            services.postFile("users/send-emails", postData, {
                                'content-type': 'multipart/form-data',
                                "Authorization": "Bearer " + self.$store.state.user.token
                            })
                            .then(res => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                if (!res.data.is_error) {
                                    self._showToast(res.data.message);
                                    self.form.template_id = null;
                                    self.form.user_emails = "";
                                    self.$validator.reset();    
                                } else {
                                    self._showToast(res.data.message, config.errMsgColorStr);
                                }
                                self.fileObj = {};
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, config.errMsgColorStr);
                            });
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        onFileChange(file, type) {
            const self = this;
            self.fileObj = {};
            if(file.length > 0){
                self.fileValidations(file,function(res){
                    if(res){
                        self.fileObj = file;
                    }
                });
            }
        },
        fileValidations(file, cb){
            const self = this;
            let fileExtension = file[0].name.split('.').pop();
            if(!self.allowFileExtDoc.includes(fileExtension.toLowerCase())){
                self._showToast(config.incorrectFileFormat, config.errMsgColorStr);
                cb(false);
            } else {
                cb(true);
            }
        },
        determineDragAndDropCapable(){
            var div = document.createElement('div');
            return ( ( 'draggable' in div )
                    || ( 'ondragstart' in div && 'ondrop' in div ) )
                    && 'FormData' in window
                    && 'FileReader' in window;
        },
        async activateDragAndDrop(){
            if(this.form.is_csv){
                this.dragAndDropCapable = await this.determineDragAndDropCapable();
                if( this.dragAndDropCapable ){
                    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
                        this.$refs.myFiles.addEventListener(evt, function(e){
                        e.preventDefault();
                        e.stopPropagation();
                        }.bind(this), false);
                    }.bind(this));
                    this.$refs.myFiles.addEventListener('drop', function(e){
                        this.onFileChange(e.dataTransfer.files);
                    }.bind(this));
                }
            }
        },
        clearFormField(){
            const self = this;
            if(self.form.is_csv){
                self.form.user_emails = '';
            }else if(!self.form.is_csv){
                self.fileObj = {};
            }
            self.$validator.reset();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/emailbroadcast/Add.vue